module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-preface element-without-heading full-character-formatting",
    attrs: {
      "id": "preface"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "preface-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Some lives can be summed up in a sentence or two.")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Other lives are epics.")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-right"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("—"), _c('i', [_vm._v("Clockwork Lives")]), _vm._v(" by Kevin J. Anderson and Neil Peart")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d1afe08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forthcoming.vue
// module id = 75
// module chunks = 0